import { HumanName } from '../../types/FHIRTypes/HumanName'

export const getHumanName = (name?: HumanName): string => {
  if (!name) return ''
  if (name.text) return name.text

  const prefix = name.prefix?.join(' ') || ''
  const given = name.given?.join(' ') || ''
  const family = name.family || ''
  const suffix = name.suffix?.join(' ') || ''


  const nameParts = [prefix, given, family, suffix].filter(Boolean).join(' ').trim()
  const period =
    name.period && (name.period.start || name.period.end)
      ? `(${[name.period.start, name.period.end].filter(Boolean).join(' — ')})`
      : ''
  return [nameParts, period].filter(Boolean).join(' ').trim()
}